import { useTranslation } from 'react-i18next';
import { Stack, Typography, type SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledRoot = styled(Stack)({
  width: '100%',
  overflow: 'auto',

  '.title': {
    flexShrink: 0,
  },
}) as typeof Stack;

const StyledDescription = styled(Typography, {
  shouldForwardProp: prop => prop !== 'title',
})<{ title: string }>(({ theme, title }) => ({
  display: 'flex',
  alignItems: 'baseline',

  '::before': {
    content: `"${title}"`,
    display: 'block',
    visibility: 'hidden',
    paddingRight: theme.spacing(1),
    ...theme.typography['Label/large'],
  },
}));

export type DrugSpecialOfferBaseProps = {
  isShareFromDorim?: boolean;
  relationDrugInfo: React.ReactNode;
  specialOfferDrugInfo: React.ReactNode;
  description: string;
  sx?: SxProps;
};

export const DrugSpecialOfferBase = (props: DrugSpecialOfferBaseProps) => {
  const { isShareFromDorim, relationDrugInfo, specialOfferDrugInfo, description, sx } = props;

  const { t } = useTranslation('drug-info');

  const title = t(`special-offer${isShareFromDorim ? '-from-dorim' : ''}.title`);

  return (
    <StyledRoot spacing={0.5}>
      <Stack direction="row" spacing={1} alignItems="center" sx={sx}>
        <Typography
          noWrap
          component="p"
          variant="Label/large"
          color={`custom.${isShareFromDorim ? 'blue' : 'red'}`}
          className="title"
        >
          {title}
        </Typography>

        <Stack direction="row" columnGap={0.5} rowGap={1} flexWrap="wrap" alignItems="center">
          {relationDrugInfo}
          <Typography component="span" variant="Body/small" color="neutral.700">
            +
          </Typography>
          {specialOfferDrugInfo}
        </Stack>
      </Stack>

      {description && (
        <StyledDescription
          title={title}
          variant="Body/small"
          color={`custom.${isShareFromDorim ? 'blue' : 'red'}`}
          className="description"
        >
          {description}
        </StyledDescription>
      )}
    </StyledRoot>
  );
};
